enum EInvoiceForwardStatus {
  ACTIVE = 'ACTIVE',
  PENDING = 'PENDING',
}
export default EInvoiceForwardStatus;
